import { TextInput } from 'common-front/src/designSystem/components/textInput';
import { RichSelect } from 'common-front/src/designSystem/form/richSelect';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { useStateDebounce } from 'common-front/src/hooks/useStateDebounce';
import { useUsersSearch } from 'common-front/src/users/search/useUsersSearch';
import { WorkflowInput, WorkflowRecipients } from 'common/src/generated/types';
import { isNonEmptyArray } from 'common/src/util/array';
import * as React from 'react';
import { WorkflowBox } from '../workflowBox';

interface IWorkflowCampaignRecipientsStepProps {
    workflow: WorkflowInput;
}

export const WorkflowCampaignRecipientsStep = (props: IWorkflowCampaignRecipientsStepProps) => {
    const {
        translate,
        params: { organizationId }
    } = useHeavent();
    const [name, nameDebounced, setName] = useStateDebounce('');
    const { usersInfosOptions, isLoading } = useUsersSearch({
        organizationId,
        eventId: null,
        hasSelected: isNonEmptyArray(props.workflow.data.usersInfosIds),
        nameDebounced,
        userInfoIds: props.workflow.data.usersInfosIds || []
    });

    return (
        <WorkflowBox
            category={translate('destinataires_19592')}
            icon="users"
            title={translate('aux_membres_sui_99877')}
        >
            <RichSelect name="workflow.data.recipients">
                <option value={WorkflowRecipients.View}>{translate('aux_membres_de_71046')}</option>
                <option value={WorkflowRecipients.DelegationsLeaders}>
                    {translate('aux_responsable_38147')}
                </option>
                <option value={WorkflowRecipients.PositionsLeaders}>
                    {translate('aux_responsable_85620')}
                </option>
                <option value={WorkflowRecipients.UsersInfosIds}>
                    {translate('_certains_memb_91094')}
                </option>
            </RichSelect>

            {props.workflow.data.recipients === WorkflowRecipients.UsersInfosIds && (
                <RichSelect
                    isSearchLoading={isLoading}
                    isSearchVisible={true}
                    label={translate('liste_des_membr_89037')}
                    multiple={true}
                    name="workflow.data.usersInfosIds"
                    searchElement={
                        <TextInput
                            icon="magnifying-glass"
                            name={name}
                            placeholder={translate('rechercher_un_m_05904')}
                            state="search"
                            onChange={setName}
                        />
                    }
                >
                    {usersInfosOptions}
                </RichSelect>
            )}
        </WorkflowBox>
    );
};
